import React, { useMemo, useState } from "react"
import { NavLink } from "react-router-dom";
import styled from "styled-components"
import menuImg from '../../resources/icons/menu.png';
import accountIcon from '../../resources/icons/account-group.png'
import { utils } from "../../utils/utils";
import MediaQuery from "react-responsive";

const HeaderMenuButtonStyled = styled.div` 
    vertical-align: top;
    line-height: 60px;
    height: 100%;
    color: #BBB;
    cursor: pointer;
    position: relative;

    &:hover {
        background-color: #121212;
    }

    &:focus {
        outline: none;
        background-color: #121212;
    }

    
    div {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
    
`

const HeaderMenuButtonMobileStyled = styled.div` 
    vertical-align: top;
    line-height: 60px;
    height: 100%;
    color: #BBB;
    cursor: pointer;
    position: relative;

    &:focus {
        outline: none;
    }

    
    div {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
    
`

const MenuPopupContainerStyled = styled.div`
    display: ${props => props.opened ? "block" : "none"};
    position: absolute;
    background-color: #252525;
    min-width: 160px;
    height: fit-content;
    width: 100%;
    overflow: auto;
    top: 60px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.1);
    z-index: 1;
`

const MenuPopupStyled = styled.ul`
    display: flex;
    height: fit-content;
    padding: 0;
    flex-direction: column;
`

const MenuItemStyled = styled.li`
    padding: 0;
    height: 60px;
    width: 100%;

    &:hover {
        background-color: #121212;
    }

    a {
        margin: 0 !important;
        
        &:hover {
            background-color: #121212 !important;
        }
    }

    // a.is-active {
    //     background-color: #252525 !important;
    // }

`

const RightMenu = styled.ul`
    float: right;
    margin-right: 100px !important;;
    display: inline;
`

// const MenuItemLink = ({from, to, onClick, withAccess, module, accessLevel}) => {
//     return <MenuItemStyled>
//         {childrenWithProps}
//     </MenuItemStyled>
// }

const MenuItem = ({ onClick, children }) => {
    return <MenuItemStyled>
        {React.cloneElement(children, { onClick: onClick })}
    </MenuItemStyled>
}

const MenuPopupContainer = ({ opened, children }) => {
    return (<MenuPopupContainerStyled opened={opened}>
        {children}
    </MenuPopupContainerStyled>)
}


const MenuHeader = ({ icon, title }) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start' }}>
            <div style={{ width: '60px', height: '60px', background: `url(${icon ? icon : menuImg}) center no-repeat` }}></div>
            <div style={{ margin: "0 10px" }}>{title}</div>
        </div>
    )
}

const HeaderMenu = (props) => {
    const { icon, children, title } = props;
    const [opened, setOpened] = useState(false);

    const onChildClick = (oldOnClick) => {
        setOpened(false);
        oldOnClick();
    }

    // const childrenWithProps = useMemo(() => React.cloneElement(children, { onClick: onChildClick }), children);
    // const childrenWithProps = React.cloneElement(children, { onClick: setOpened(false) });

    const handleBlur = (event) => {
        // if the blur was because of outside focus
        // currentTarget is the parent element, relatedTarget is the clicked element
        if (!event.currentTarget.contains(event.relatedTarget)) {
            setOpened(false);
        }
    }

    return (
        <>
            <MediaQuery minDeviceWidth={1224}>
                <HeaderMenuButtonStyled icon={icon} tabIndex={1} onClick={() => setOpened(!opened)} onBlur={handleBlur}>
                    <MenuHeader icon={icon} title={title} />
                    <MenuPopupContainer opened={opened}>
                        <MenuPopupStyled>
                            {Array.isArray(children) ?
                                children.map((element) => React.cloneElement(element, { key: utils.generateUuid(), onClick: () => onChildClick(element.props.onClick) })) :
                                children ? React.cloneElement(children, { onClick: () => onChildClick(children.props.onClick) }) : <></>
                            }
                        </MenuPopupStyled>
                    </MenuPopupContainer>
                </HeaderMenuButtonStyled>
            </MediaQuery>
            <MediaQuery maxDeviceWidth={1224}>
                <HeaderMenuButtonMobileStyled icon={icon} tabIndex={0} onClick={() => setOpened(!opened)} onBlur={handleBlur}>
                    <MenuHeader icon={icon} title={title} />
                    <MenuPopupStyled>
                        {
                            opened && (Array.isArray(children) ?
                                children.map((element) => React.cloneElement(element, { key: utils.generateUuid(), onClick: () => onChildClick(element.props.onClick) })) :
                                children ? React.cloneElement(children, { onClick: () => onChildClick(children.props.onClick) }) : <></>)
                        }
                    </MenuPopupStyled>
                </HeaderMenuButtonMobileStyled>

            </MediaQuery>
        </>
    )
}

const AdministrationMenu = ({ children, ...other }) => {
    return <HeaderMenu {...other} icon={accountIcon}>
        {children}
    </HeaderMenu>
}

export { HeaderMenu, MenuItem, RightMenu, AdministrationMenu }